import { render, staticRenderFns } from "./EditPriceSelect.vue?vue&type=template&id=01099d62"
import script from "./EditPriceSelect.vue?vue&type=script&lang=js"
export * from "./EditPriceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports